// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1tEGH","col":"styles_col__3-fma"};